import type { Enemy } from '../Enemy';
import type { MovementBehavior } from './MovementBehavior';
import { getEnemyMovementTopY, getEnemyMovementBottomY } from '../../constants/field';
import { getEnemyMobileSpeedMultiplier } from '../../constants/scale';

export class DriftingChaseBehavior implements MovementBehavior {
  private elapsedMs = 0;
  private wobbleAmplitude = 30;
  private wobbleFrequency = 0.8;
  private startY = 0;

  init(enemy: Enemy, params?: Record<string, number>): void {
    if (params) {
      this.wobbleAmplitude = params.wobbleAmplitude ?? this.wobbleAmplitude;
      this.wobbleFrequency = params.wobbleFrequency ?? this.wobbleFrequency;
    }
    this.startY = enemy.y;
  }

  update(enemy: Enemy, deltaMs: number, target: { x: number; y: number }): void {
    this.elapsedMs += deltaMs;

    const dx = target.x - enemy.x;
    const dist = Math.abs(dx);
    if (dist < 1) return;

    const effectiveSpeed = enemy.config.speed * getEnemyMobileSpeedMultiplier();
    const moveDistance = (effectiveSpeed * deltaMs) / 1000;
    enemy.x += Math.sign(dx) * moveDistance;

    const wobble =
      Math.sin((this.elapsedMs / 1000) * this.wobbleFrequency * Math.PI * 2) *
      this.wobbleAmplitude;
    const halfSize = enemy.displayWidth / 2;
    const minY = getEnemyMovementTopY(enemy.scene) + halfSize;
    const maxY = getEnemyMovementBottomY(enemy.scene) - halfSize;
    enemy.y = Math.max(minY, Math.min(maxY, this.startY + wobble));
  }
}
